import { Button, MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledBtnText = styled.span``
export const StyledRow = styled.div``
export const StyledColLeft = styled.div``
export const StyledColRight = styled.div``

export const StyledCommunityButton = styled(Button)``
export const StyledInputCommentBar = styled.div`
  .reply-to-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    width: 100%;
  }

  &[data-is-input-style='true'] {
    ${StyledRow} {
      display: flex;
    }
    ${StyledColLeft} {
      width: 48px;
    }
    ${StyledColRight} {
      width: calc(100% - 48px);
    }
    &[data-is-reply='true'] {
      ${StyledColLeft} {
        width: 40px;
      }
      ${StyledColRight} {
        width: calc(100% - 40px);
      }
    }
    .error-text {
      padding: 1rem;
      color: ${(props: ThemeProps) => props.theme.colors.red700};
    }
    .reply-to-container {
      .icon-close-comment {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
      a {
        text-decoration: none;
      }
    }
    .input-container {
      display: flex;

      .avatar-wrapper {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        margin-right: 0.5rem;
        &.avatar-wrapper-reply {
          width: 32px;
          height: 32px;
          .avatar {
            width: 32px;
            height: 32px;
          }
        }
      }
      .input-wrapper {
        &[data-has-error] {
          .as-input {
            border-color: ${(props: ThemeProps) => props.theme.colors.red700};
          }
        }

        .as-input {
          .toolbar {
            position: absolute;
            top: auto;
            bottom: 0;
            ${MediaQueries.mbUp} {
              left: -9px;
            }
          }
          .textarea {
            width: 100%;
            max-height: 225px;
            min-height: 75px;

            .ql-toolbar {
              padding: 0;
              left: -9px;
              background: transparent !important;
            }
            .ql-editor {
              margin-bottom: 24px;
              margin-left: 0;
              padding: 0;
            }
          }
          width: 100%;
          padding: 16px;
          border: solid 1px #e4e8ec;
          border-radius: 6px;

          ${MediaQueries.mbDown} {
            padding: 16px;

            .ql-editor {
              margin-left: 0 !important;
              padding-top: 0;
            }
          }

          &:focus-within,
          &:focus {
            border-color: ${(props: ThemeProps) =>
              props.theme.colors.primaryBase};
            box-shadow: 0px 0px 2px 2px
              ${(props: ThemeProps) => props.theme.colors.blue200};
          }

          &:disabled {
            background-color: ${(props: ThemeProps) =>
              props.theme.colors.gray100};
            cursor: not-allowed;
          }

          span {
            &[data-error='true'] {
              color: red;
              text-decoration: underline;
            }
          }
        }

        &[data-has-action-icon] {
          .as-input {
            padding: 12px 48px 12px 16px;
          }
        }
        &[data-has-display-icon] {
          .as-input {
            padding: 12px 16px 12px 48px;
          }
        }

        &[data-has-action-icon][data-has-display-icon] {
          .as-input {
            padding: 12px 48px;
          }
        }

        &[data-size='lg'] {
          .as-input {
            font-size: 16px;
            font-weight: ${(props: ThemeProps) => props.theme.sizes.fwRegular};
            ${MediaQueries.mbDown} {
              font-size: 22px;
              line-height: 1.2;
            }

            ${MediaQueries.mbUp} {
              font-size: 26px;
              line-height: 1.2;
            }
          }
        }
        &[data-size='md'] {
          .as-input {
            font-weight: ${(props: ThemeProps) => props.theme.sizes.fwRegular};
            line-height: 22px;
            ${MediaQueries.mbDown} {
              font-size: 14px;
              line-height: 1.2;
            }

            ${MediaQueries.mbUp} {
              font-size: 16px;
              line-height: 1.2;
            }
          }
        }
        &[data-size='sm'] {
          .as-input {
            font-weight: ${(props: ThemeProps) => props.theme.sizes.fwRegular};
            line-height: 20px;
            ${MediaQueries.mbDown} {
              font-size: 13px;
              line-height: 1.5;
            }

            ${MediaQueries.mbUp} {
              font-size: 13px;
              line-height: 1.5;
            }
          }
        }
      }
      .images-input-label {
        height: 100%;
        cursor: pointer;
        .icon-images-input {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
      }
    }
    .preview-images-container {
      margin-top: 1rem;
      .image-src-wrapper {
        position: relative;
        width: 100%;
        padding-top: 66.67%;
        &:not(:last-child) {
          margin-bottom: 1rem;
        }
        .preview-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .icon-close-circle {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }
    }

    ${MediaQueries.mbDown} {
      .button-icon {
        & + span {
          display: none;
        }
      }
    }

    ${StyledCommunityButton} {
      display: flex;

      flex-shrink: 0;
      align-items: center;
      justify-content: center;

      border: none;
      position: absolute;
      right: 16px;
      bottom: 16px;
      z-index: 3;
      padding: 0;
      // padding-left: 16px;
      // padding-right: 16px;

      &,
      &:hover {
        background: transparent !important;
      }

      ${StyledBtnText} {
        display: none;
      }

      ${MediaQueries.mbDown} {
        padding: 0 !important;
        width: 40px;
        height: 40px;
        right: 8px;
        bottom: 8px;
        background: transparent !important;
        border: 0 !important;
      }

      ${MediaQueries.mbUp} {
        // .icon-enter {
        //   display: none;
        // }
        border: 0 !important;
        ${StyledBtnText} {
          display: block;
        }
      }

      &.send-button-post {
        background: ${(props: ThemeProps) => props.theme.colors.neutral100};
        border-radius: 50%;
      }
      .icon-enter {
        // width: 20px;
        // height: 20px;
        vertical-align: middle;
      }
      &[data-is-loading='true'] {
        > div {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
`

export const StyledInputCommentPost = styled.div`
  position: relative;
  .card-textbox-overlay {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
`

export const StyledMarryBabyInputCommentPostUI = styled.div`
  padding: 1rem;
  .upper-container {
    display: flex;
    align-items: center;
    padding-bottom: 1rem;
    border-bottom: 1px solid #fafafa;

    .avatar-wrapper {
      width: 40px;
      height: 40px;
      margin-right: 1rem;
    }
  }
  .action-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 1rem;
    .image-picker-icon,
    .video-picker-icon {
      width: 24px;
      height: 24px;
      margin-right: 0.5rem;
    }
    .image-picker-wrapper,
    .video-picker-wrapper {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
    }
  }
`

export const StyledTogetherInputCommentPostUI = styled.div`
  padding: 1rem;
  border-radius: 6px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  .input-wrapper {
    flex: 1;
    display: flex;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 0.5rem 1.25rem;
    margin-left: 0;
    align-items: center;

    ${MediaQueries.mbUp} {
      margin-left: 1rem;
      margin-right: 1rem;
    }
    .pencil-icon {
      width: 19px;
      height: 19px;
      margin-right: 10px;
    }
  }
  .right-button {
    background: #f2f2f2;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    .image-icon {
      width: 18px;
      height: 18px;
    }
  }
`
export const StyledEditorArea = styled.div``
export const StyledRichTextWRapper = styled.div``
export const StyledActions = styled.div`
  display: flex;
`
